import * as React from 'react';
import { get } from 'lodash';
import FileDownload from 'material-ui/svg-icons/file/file-download';

import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

import { itemStateEnum } from '@modules/operationalWarehouse/_operationalWarehouseEnums';
import { downloadFile } from '@utils/actions';

export default [
  {
    label: 'Název',
    field: 'name',
    type: ColumnType.TEXT,
    width: 180
  },
  {
    label: 'Kategorie',
    field: 'category.name',
    displayField: 'category',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 180
  },
  {
    label: 'Sklad',
    field: 'warehouse.name',
    displayField: 'warehouse',
    mapper: parent => get(parent, 'name'),
    type: ColumnType.TEXT,
    width: 180
  },
  {
    label: 'Stav předmětu',
    field: 'state',
    type: ColumnType.ENUM,
    enum: itemStateEnum,
    width: 210
  },
  {
    label: 'Strážník',
    field: 'employee.name',
    displayField: 'employee',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 180
  },
  {
    label: 'Poznámka',
    field: 'note',
    type: ColumnType.TEXT,
    width: 300
  }
];

export const operationalWarehouseFormHistoriesColumns = [
  { label: 'Uživatel', field: 'user', type: ColumnType.TEXT, width: 100 },
  { label: 'Datum a Čas', field: 'created', type: ColumnType.DATETIME, width: 100 },
  {
    label: 'Před',
    field: 'before',
    type: ColumnType.ENUM,
    enum: itemStateEnum,
    mapper: o => get(o, 'state'),
    width: 100
  },
  {
    label: 'Po',
    field: 'after',
    type: ColumnType.ENUM,
    enum: itemStateEnum,
    mapper: o => get(o, 'state'),
    width: 100
  },
  {
    label: 'Poznámka',
    field: 'after',
    type: ColumnType.TEXT,
    mapper: o => get(o, 'note'),
    width: 400
  }
];

export const operationalWarehouseFormFilesColumns = [
  { label: 'Název', field: 'name', type: ColumnType.TEXT, width: 500 },
  {
    label: 'Akce',
    field: 'action',
    type: ColumnType.JSX,
    width: 100,
    jsx: ({ row }) => (
      <div>
        <FileDownload onClick={() => downloadFile(row.id, row.name)} />
      </div>
    )
  }
];



// WEBPACK FOOTER //
// ./src/modules/operationalWarehouse/_operationalWarehouseColumns.tsx